var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "product-list-form-container" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "List name" } },
                [
                  _c("b-form-input", {
                    attrs: { id: "product-list-name", type: "text" },
                    model: {
                      value: _vm.productListName,
                      callback: function ($$v) {
                        _vm.productListName = $$v
                      },
                      expression: "productListName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticClass: "d-flex justify-content-end" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: { click: _vm.handleImportProducts },
                  },
                  [_vm._v("\n          Import Products\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "ml-2",
                    attrs: { variant: "primary" },
                    on: { click: _vm.showProductRecordModal },
                  },
                  [_vm._v("\n          Add Product\n        ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pt-3 mt-3 border-top" },
              [
                _c("b-table", {
                  attrs: {
                    items: _vm.productRecords,
                    fields: _vm.productRecordsFields,
                    "empty-text": "No products added yet",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "cell(product_image)",
                      fn: function (data) {
                        return [
                          _c("img", {
                            staticClass: "w-10 h-8",
                            attrs: {
                              src: data.item.product_image
                                ? data.item.product_image.url
                                : data.item.productImage.url,
                              alt: data.item.product_name,
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "cell(upc)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(data.item.upc || "-") +
                              "\n          "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(brand)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(data.item.brand || "-") +
                              "\n          "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(variant)",
                      fn: function (data) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(data.item.variant || "-") +
                              "\n          "
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(primary_color)",
                      fn: function (data) {
                        return [
                          data.item.primary_color
                            ? _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("div", {
                                    staticClass: "w-6 h-6 rounded",
                                    style: {
                                      backgroundColor: data.item.primary_color,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "ml-2" }, [
                                    _vm._v(_vm._s(data.item.primary_color)),
                                  ]),
                                ]
                              )
                            : _c("div", [
                                _vm._v("\n              -\n            "),
                              ]),
                        ]
                      },
                    },
                    {
                      key: "cell(secondary_color)",
                      fn: function (data) {
                        return [
                          data.item.secondary_color
                            ? _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("div", {
                                    staticClass: "w-6 h-6 rounded",
                                    style: {
                                      backgroundColor:
                                        data.item.secondary_color,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "ml-2" }, [
                                    _vm._v(_vm._s(data.item.secondary_color)),
                                  ]),
                                ]
                              )
                            : _c("div", [
                                _vm._v("\n              -\n            "),
                              ]),
                        ]
                      },
                    },
                    {
                      key: "cell(actions)",
                      fn: function (data) {
                        return [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.showProductRecordModal(
                                    data.item,
                                    "edit"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n              Edit\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "danger" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleRemoveProduct(data.item)
                                },
                              },
                            },
                            [_vm._v("\n              Remove\n            ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-end",
              attrs: { cols: "12" },
            },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary" },
                  on: { click: _vm.handleCancel },
                },
                [_vm._v("\n        Cancel\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "ml-2",
                  attrs: { variant: "primary" },
                  on: { click: _vm.handleSave },
                },
                [_vm._v("\n        Save\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ProductRecordModal", {
        ref: "productRecordModal",
        on: { save: _vm.handleAddProductRecord },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }